import { render, staticRenderFns } from "./SendingRequest.vue?vue&type=template&id=70132064&scoped=true&"
import script from "./SendingRequest.vue?vue&type=script&lang=js&"
export * from "./SendingRequest.vue?vue&type=script&lang=js&"
import style0 from "./SendingRequest.vue?vue&type=style&index=0&id=70132064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70132064",
  null
  
)

export default component.exports